import { colorsPalettes } from "@similarweb/styles";

export const loaderOptions = {
    svg: {
        stroke: colorsPalettes.midnight[50],
        strokeWidth: "4",
        r: 21,
        cx: "50%",
        cy: "50%",
    },
    style: {
        width: 46,
        height: 46,
    },
};
export const MAX_COMP_DOMAIN_IN_TOOLTIP = 5;
export const SETUP_BACKGROUND_IMAGE = "/images/activation/activation-setup-background.png";
